// src/pages/NotFound.jsx
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen pt-16 bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="text-7xl mb-4">🌿</div>
        <h1 className="text-5xl font-bold text-gray-900 mb-3">404</h1>
        <p className="text-gray-500 mb-6">Oops! This page got lost in the garden.</p>
        <Link to="/" className="px-6 py-3 bg-[#2e7d32] text-white font-semibold rounded-xl hover:bg-[#1b5e20] transition-colors">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
